module.exports = __webpack_public_path__ + "static/media/YF61_3.286983cb.jpg";